import PropTypes from 'prop-types';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import style from './low-stock-banner.module.less';
import { messages } from './messages';

// this value is used in the messages.externalInventorySource as a key.
// if you change this value, be sure to change that message as well.
const unknownInventoryProviderValue = 'unknown';

const NativeInventoryProviderName = 'ShipStation';

export const LowStockBanner = ({ inventoryProviderName = unknownInventoryProviderValue }) => {
  const lowStockMessage =
    inventoryProviderName === NativeInventoryProviderName ? messages.nativeInventory : messages.externalInventorySource;

  return (
    <div className={style['low-stock-banner']}>
      <BannerMessageV2
        content={<Text formattedMessageValues={{ inventoryProviderName }} textType={TextType.Paragraph} value={lowStockMessage} />}
        status={BannerStatus.Error}
      />
    </div>
  );
};

LowStockBanner.propTypes = {
  inventoryProviderName: PropTypes.string,
};
